import {
  EInitEventDisruptionPvsShiftStateCode,
  EInitEventDisruptionPvsTaskStateCode,
} from 'ngx-mt-ui-lib/api-client';

export {
  EInitEventDisruptionPvsShiftStateCode as EPvsShiftStatusCode,
  EInitEventDisruptionPvsTaskStateCode as EPvsTaskStatusCode,
};

/**
 * Источник координат ПВС
 */
export enum EPvsShiftCoordSurce {
  /**
   * Бригадир
   */
  FOREMAN = 1,
  /**
   * ТС
   */
  TRANSPORT = 0,
}

export const pvsShiftStateColor: Record<
  EInitEventDisruptionPvsShiftStateCode,
  string
> = {
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_SCHEDULED]: '#F0A93B',
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_ON_THE_WAY]: '#FB923C',
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_IN_PROGRESS]: '#60A5FA',
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_AT_THE_OBJECT]: '#2563EB',
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_AVAILABLE]: '#22C55E',
  [EInitEventDisruptionPvsShiftStateCode.PVS_SHIFT_COMPLETED]: '#64748B',
};

export const pvsTaskStateColor: Record<
  EInitEventDisruptionPvsTaskStateCode,
  string
> = {
  [EInitEventDisruptionPvsTaskStateCode.PVS_TASK_CANCEL]: '#FB923C',
  [EInitEventDisruptionPvsTaskStateCode.PVS_TASK_IN_PROGRESS]: '#60A5FA',
  [EInitEventDisruptionPvsTaskStateCode.PVS_TASK_ASSIGNING]: '#2563EB',
  [EInitEventDisruptionPvsTaskStateCode.PVS_TASK_COMPLETE]: '#22C55E',
};
